import { useSessionStore } from "@/stores/session.store";
import * as Sentry from "@sentry/vue";
import { watchEffect } from "vue";

export const useSentry = () => {
  const sessionStore = useSessionStore();
  watchEffect(() => {
    if (!Sentry.isInitialized()) return;
    const workspace = sessionStore.selectedWorkspace();
    const user = sessionStore.selectedUser();
    if (user && workspace) {
      Sentry.setTag("workspace", workspace.id);
      Sentry.setUser({
        id: user.id,
        email: user.email,
        name: `${user.givenName} ${user.familyName}`
      });
    } else {
      Sentry.setUser(null);
    }
  });
};
